const gap = "[\\s\\u00ad\\u034f\\u061c\\u180e\\u200b-\\u200f\\u202a-\\u202e\\u2060-\\u206f\\ufeff]*";
const word = (value: string) => value.split("").join(gap);
const names = `(?:${word("channel")}|${word("here")}|${word("everyone")})`;
const rawAngleBroadcast = new RegExp(`<${gap}!?${gap}${names}(?:${gap}\\|[^>]*)?${gap}>`, "gi");
const encodedAngleBroadcast = new RegExp(
  `(?:&lt;|&#0*60;|&#x0*3c;)${gap}!?${gap}${names}(?:${gap}\\|(?:(?!&gt;|&#0*62;|&#x0*3e;)[\\s\\S])*)?${gap}(?:&gt;|&#0*62;|&#x0*3e;)`,
  "gi",
);
const literalBroadcast = new RegExp(`(^|[^\\w])@${gap}${names}\\b`, "gi");
const legacyMarker = /\{\{BCHANNEL_PING\}\}/gi;
const typedMarker = /\{\{BCHANNEL_BROADCAST:(?:channel|here)\}\}/gi;

/**
 * Removes every Slack broadcast spelling accepted or defensively treated as
 * suspicious. `<!subteam^...>` user-group mentions are NOT broadcasts: Slack
 * lets any member mention a user group, so they stay in no-ping messages.
 */
export function stripBroadcastAttempts(value: string) {
  return value
    .replace(rawAngleBroadcast, "")
    .replace(encodedAngleBroadcast, "")
    .replace(legacyMarker, "")
    .replace(typedMarker, "")
    .replace(literalBroadcast, "$1");
}
